import { RootState } from "../store";

// eslint-disable-next-line import/prefer-default-export
export const getAuthData = (state: RootState) => state.auth
